import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../services/api';
import '../styles/dashboard.css';
import Topbar from '../components/dashboard/Topbar';
import Hero from '../components/dashboard/Hero';
import Stats from '../components/dashboard/Stats';
import VenditeCard from '../components/dashboard/VenditeCard';
import BudgetSpesaCard from '../components/dashboard/BudgetSpesaCard';
import VenditeContattiCard from '../components/dashboard/VenditeContattiCard';
import CostiPrevistiRealiCard from '../components/dashboard/CostiPrevistiRealiCard';
import RicaviMarginiCard from '../components/dashboard/RicaviMarginiCard';
import CurveForecastSection from '../components/dashboard/CurveForecastSection';

export default function Dashboard() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchStats() {
      try {
        const res = await api.get(`/dashboard/${id}/stats`);
        setData(res.data);
        setError(null);
      } catch (err) {
        if (err.response && err.response.status === 404) {
          setError('Progetto non trovato');
        } else {
          console.error('Errore recupero dashboard stats', err);
        }
      }
    }
    fetchStats();
  }, [id]);

  if (error) {
    return (
      <div className="container-dash">
        <p>{error}</p>
      </div>
    );
  }

  const projectName = data?.projectName || 'Nome progetto';
  const capitaleInvestito = data?.capitaleInvestito ?? 1;

  return (
    <div className="container-dash">
      <Topbar
        projectName={projectName}
        capitaleInvestito={capitaleInvestito}
        cantiereId={id}
        onCapitaleUpdated={(val) =>
          setData((prev) => ({ ...prev, capitaleInvestito: val }))
        }
      />
      <Hero projectName={projectName} />
      <Stats data={data} />
      <div className="grid-dash">
        <VenditeCard />
        <BudgetSpesaCard data={data} />
      </div>
      <VenditeContattiCard />
      <div className="grid-dash">
        <CostiPrevistiRealiCard data={data} />
        <RicaviMarginiCard data={data} />
      </div>
      <CurveForecastSection />
    </div>
  );
}
